import { routes } from "@/router/routes";

type RouteNode = {
  path?: string;
  children?: RouteNode[];
  [key: string]: unknown;
};

const traverse = (node: RouteNode, paths: string[]): void => {
  // Добавляем текущий путь
  if (node.path) {
    paths.push(node.path);
  }

  // Если есть дети, рекурсивно обходим их
  if (node.children && node.children.length) {
    node.children.forEach((child) => traverse(child, paths));
  }
};

export const collectPaths = (node: RouteNode | RouteNode[]): string[] => {
  const paths: string[] = [];

  // Поддержка случая, когда node является массивом
  if (Array.isArray(node)) {
    node.forEach((n) => traverse(n, paths));
  } else {
    traverse(node, paths);
  }

  return [...new Set(paths)];
};

export const getAllUrls = (): string[] => collectPaths(routes);

const newAppRegex = /new_application/;
const reAppRegex = /reapplication/;

export const getUrlsWithAmount = (urls: string[]): string[] =>
  urls.filter((url) => newAppRegex.test(url) || reAppRegex.test(url));

const noHeaderTopRegex = /change-number/;

export const getUrlsNoHeaderTop = (urls: string[]): string[] =>
  urls.filter(
    (url) => noHeaderTopRegex.test(url) || url === "/choosing-reset-method"
  );
